import { journeySerializer } from '@/providers/serializers/journey/journey';
import { http } from '../http';

export class JourneyAPI {

    private static INSTANCE = new JourneyAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/nucleus-insights/v2';

    private nucleusNamespace: string = 'api/nucleus/v1';

    public fetchClassPerformance(params: any, userId: string) {
        const endpoint = `${this.namespace}/classes/performance?userId=${userId}`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, params).then((response) => {
            return response.data.usageData;
        });
    }

    public fetchClassMilestones(params: any) {
        const endpoint = `${this.nucleusNamespace}/courses/ms/${params.courseId}/fw/${params.fwCode}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params.queryParams).then((response) => {
            return journeySerializer.normalizeMilestones(response.data);
        });
    }

    public fetchMilestoneDetails(params: any) {
        const endpoint = `${this.nucleusNamespace}/courses/ms/${params.courseId}/milestones/${params.milestoneId}`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return journeySerializer.normalizeMilestoneLessons(response.data);
        });
    }

}

export const journeyAPI = JourneyAPI.instance;

